export const HEADER_CONTENT_COLOR = 'common.white' as const;
